<div style="border-left-style: dashed">
  <div style="border-left-style: 'display: table-row;'">
    <div class="btn-group btn-toggle" style="padding-left: 35%">
      <button class="btn btn-lg"  (click)="showVoiceMail()" [ngClass]="{ 'btn-default': isVoiceMail, 'btn-primary active': !isVoiceMail}">Normal</button>
      <button class="btn btn-lg" (click)="showVoiceMail()" [ngClass]="{ 'btn-default': !isVoiceMail, 'btn-primary active': isVoiceMail}">Voicemail</button>
    </div>
    <!--div style="text-align: center; text-align: -webkit-center; text-align: -moz-center;">
      <span> The text below is just showing an example of what the finally selected sounds should say in case of {{isVoiceMail ? 'Voicemail' : 'Normal'}}</span>
    </div-->
    <div style="display: table-cell; vertical-align: top; padding-top: 20px;">
      <!--button class="btn btn-default" style="padding: 0; border-style: none; font-size: 40px"
              *ngIf="!isPlayAll"
              (click)="playAll(0);" tooltip="Play full message"
      ><i class="glyphicon glyphicon-play"></i></button>
      <button class="btn btn-default" style="padding: 0; border-style: none; font-size: 40px"
              *ngIf="isPlayAll"
              (click)="stop();" tooltip="Stop playing full message"
      ><i class="glyphicon glyphicon-stop"></i></button-->
    </div>
    <div style="display: table-cell;" *ngIf="contextVariables !== []">
      <div *ngFor="let voice of twilioVoice; let i = index;">
        <div *ngIf="voice.containsAppointment !== undefined && voice.containsAppointment === 'start'">
          <hr>
        </div>
        <twilio-voice-parameter [type]="voice.type"
                        [ttsMessage]="voice.model !== undefined && updatedModel !== undefined ? voice.ttsMessage : ''"
                        [contextVariables]="contextVariables"
                        [model]="voice.model"
                        [isOnlyPreview]="isOnlyPreview"
                        [audioService]="voice.audioService"
                        [src]="voice.src"
                        [playSequence]="playSequence"
                        [sequenceNumber]="i"
                        (isEnded)="isEnded()"
                        [soundName]="voice.name"
                        [isAppointment]="voice.isAppointment"
                        (selectedNodeChange)="selectedNodeChange.emit($event)"
        ></twilio-voice-parameter>
        <div class="btn-group btn-toggle" style="padding-left: 32%" *ngIf="containsMoreThanOneLanguage && voice.name === 'press1spanish'">
          <button class="btn btn-lg"  (click)="changeLanguage()" [ngClass]="{ 'btn-default': selectedLanguage !== 'EN', 'btn-primary active': selectedLanguage === 'EN'}">English</button>
          <button class="btn btn-lg" (click)="changeLanguage()" [ngClass]="{ 'btn-default': selectedLanguage === 'EN', 'btn-primary active': selectedLanguage !== 'EN'}">Spanish</button>
        </div>

        <div *ngIf="voice.containsAppointment !== undefined && voice.containsAppointment === 'end'">
          <hr>
        </div>
      </div>
    </div>
  </div>
</div>
